/** Productmerk van BRES: dak boven twee regels (aanbod en publicatie). Kleur via currentColor. */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 32 32" aria-hidden focusable="false">
      <rect x="1" y="1" width="30" height="30" rx="9" fill="currentColor" opacity="0.16" />
      <path d="M8 15.5 16 9l8 6.5" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.5 19.5h11M10.5 23.5h11" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}
